import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationModule } from '../avano-validation/validation.module';
import { AvanoButtonBarButtonComponent } from './avano-button-bar-button/avano-button-bar-button.component';
import { AvanoButtonBarIsActivePipe } from './avano-button-bar-button/avano-button-bar-is-active.pipe';
import { AvanoButtonBarLabelPipe } from './avano-button-bar-button/avano-button-bar-label.pipe';
import { AvanoButtonBarButtonGroup } from './avano-button-bar-buttongroup.pipe';
import { AvanoButtonBarCollapseExpandAllComponent } from './avano-button-bar-collapse-expand-all/avano-button-bar-collapse-expand-all.component';
import { AvanoButtonBarHelpComponent } from './avano-button-bar-help/avano-button-bar-help.component';
import { AvanoButtonBarComponent } from './avano-button-bar.component';
import { TriggeredReEvaluatePipe } from './pipes/triggered-re-evaluate.pipe';

@NgModule({
  imports: [CommonModule, TranslateModule.forChild({ extend: true }), 
    ValidationModule
  ],
  exports: [AvanoButtonBarComponent, TriggeredReEvaluatePipe],
  declarations: [
    AvanoButtonBarComponent,
    AvanoButtonBarButtonGroup,
    AvanoButtonBarLabelPipe,
    AvanoButtonBarIsActivePipe,
    TriggeredReEvaluatePipe,
    AvanoButtonBarButtonComponent,
    AvanoButtonBarHelpComponent,
    AvanoButtonBarCollapseExpandAllComponent,
  ],
  providers: [
    TriggeredReEvaluatePipe
  ]
})
export class AvanoButtonBarModule {}
